
<template>
  <div>
    <h2>Notificar medicamentos</h2>
    <b-form-group label="Tipo Documento:" label-for="input-3">
      <v-select
        v-model="notification.documentType"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :clearable="false"
        label="description"
        placeholder="-- Por favor seleccione una opcion --"
        :options="documentsType"
        :reduce="(option) => option.id"
      />
      <small v-if="errors['documentsType']" class="text-danger">{{
        errors["documentsType"][0]
      }}</small>
    </b-form-group>
    <b-form-group id="input-group-2" label="Documento" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="notification.document"
        placeholder="Documento"
        required
      ></b-form-input>
      <small v-if="errors['document']" class="text-danger">{{
        errors["document"][0]
      }}</small>
    </b-form-group>
    <b-form-group id="input-group-2" label="Nombre" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="notification.name_client"
        placeholder="Nombre"
        required
      ></b-form-input>
      <small v-if="errors['name_client']" class="text-danger">{{
        errors["name_client"][0]
      }}</small>
    </b-form-group>
    <b-form-group id="input-group-2" label="Apellidos" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="notification.surnames"
        placeholder="Apellido"
        required
      ></b-form-input>
      <small v-if="errors['surnames']" class="text-danger">{{
        errors["surnames"][0]
      }}</small>
    </b-form-group>
    <b-form-group label="Tipo notificación" v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        id="radio-group-1"
        v-model="notification.mediaType"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="radio-options"
      ></b-form-radio-group>
      <small v-if="errors['mediaType']" class="text-danger">{{
        errors["mediaType"][0]
      }}</small>
    </b-form-group>
    <b-form-group
      id="input-group-2"
      label="Email"
      label-for="input-2"
      v-if="notification.mediaType == '1'"
    >
      <b-form-input
        id="input-2"
        v-model="notification.email"
        placeholder="Correo"
        required
      ></b-form-input>
      <small v-if="errors['email']" class="text-danger">{{
        errors["email"][0]
      }}</small>
    </b-form-group>

    <b-form-group
      id="input-group-2"
      label="Teléfono"
      label-for="input-2"
      v-if="notification.mediaType == '2' || notification.mediaType == '3'"
    >
      <b-form-input
        id="input-2"
        v-model="notification.phone"
        placeholder="telefono"
        required
      ></b-form-input>
      <small v-if="errors['phone']" class="text-danger">{{
        errors["phone"][0]
      }}</small>
    </b-form-group>

    <b-form-group
      id="input-group-whatsapp"
      label="WhatsApp"
      label-for="input-whatsapp-number"
      v-if="notification.mediaType == '4'"
    >
      <div class="d-flex gap-2">
        <v-select
          v-model="whatsapp.country"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :clearable="false"
          label="name"
          :options="countries"
          :reduce="(option) => option.code"
          style="min-width: 220px"
          placeholder="Indicativo"
        >
          <template #selected-option="{ name, dialCode }"
            >+{{ dialCode }} {{ name }}</template
          >
          <template #option="{ name, dialCode }"
            >+{{ dialCode }} {{ name }}</template
          >
        </v-select>
        <b-form-input
          id="input-whatsapp-number"
          v-model="whatsapp.number"
          placeholder="Ej: 3101234567"
          required
        ></b-form-input>
      </div>
      <small v-if="whatsappError" class="text-danger">{{
        whatsappError
      }}</small>
      <small v-if="errors['phone']" class="text-danger">{{
        errors["phone"][0]
      }}</small>
    </b-form-group>
    <b-form-checkbox
      id="checkbox-1"
      v-model="notification.processingPersonalData"
      name="checkbox-1"
      unchecked-value="not_accepted"
    >
        Acepto los
        <a href="https://indiju.com.co/index.php/terminos-y-condiciones/" target="_blank">terminos y condiciones</a>
        y la
        <a href="https://indiju.com.co/index.php/politica-de-privacidad/" target="_blank">politica de privacidad</a>
    </b-form-checkbox>
    <small v-if="errors['processingPersonalData']" class="text-danger mt-1">{{
      errors["processingPersonalData"][0]
    }}</small>
    <b-button
      class="btn-sm mt-1"
      block
      :disabled="isSubmitting"
      @click="enviarNotificacion"
    >
      <b-spinner small v-if="isSubmitting" />
      {{ isSubmitting ? "Enviando..." : "Enviar" }}
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormInput,
  BButton,
  BFormRadioGroup,
  BFormSelect,
  BFormSelectOption,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import {
  getCountries,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "libphonenumber-js";
export default {
  props: {
    search: {
      type: Object,
    },
    cumDetail: {
      type: Object,
    },
  },
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormInput,
    BButton,
    BFormRadioGroup,
    BFormSelect,
    BFormSelectOption,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      isSubmitting: false,
      notification: {
        documentType: "",
        processingPersonalData: false,
      },
      options: [],
      errors: [],
      documentsType: [],
      countries: [],
      whatsapp: {
        country: "CO",
        number: "",
      },
    };
  },
  computed: {
    selectedCountry() {
      return this.countries.find((c) => c.code === this.whatsapp.country);
    },
    whatsappError() {
      if (!this.whatsapp.number) {
        return "";
      }
      const valid = isValidPhoneNumber(this.whatsapp.number, this.whatsapp.country);
      return valid
        ? ""
        : `Ingresa un número válido para ${this.selectedCountry ? this.selectedCountry.name : this.whatsapp.country} (indicativo +${this.selectedCountry ? this.selectedCountry.dialCode : ""})`;
    },
  },
  methods: {
    buildCountries() {
      const regionNames = new Intl.DisplayNames(["es"], { type: "region" });
      this.countries = getCountries()
        .map((code) => ({
          code,
          dialCode: getCountryCallingCode(code),
          name: regionNames.of(code) || code,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    getMedias() {
      this.$http.get(`/medias`).then((res) => {
        this.options = res.data.data;
      });
    },
    getDocuments() {
      this.$http.get(`/documenttypes`, { params: { scope: 'natural', perPage: 50 } }).then((res) => {
        this.documentsType = res.data.document_types;
      });
    },
    enviarNotificacion() {
      if (this.notification.mediaType == "4") {
        if (!this.whatsapp.number || this.whatsappError) {
          this.errors = { phone: ["Ingresa un número de WhatsApp válido"] };
          return;
        }
        this.notification.phone = `+${this.selectedCountry.dialCode} ${this.whatsapp.number}`;
      }
      if (this.isSubmitting) {
        return;
      }
      let notificationRequest = Object.assign(this.notification, this.search);
      notificationRequest = Object.assign(notificationRequest, this.cumDetail);
      const _this = this;
      this.errors = [];
      this.isSubmitting = true;
      this.$http
        .post(`/cum/notification`, notificationRequest)
        .then((res) => {
          _this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Notificación`,
              icon: "CoffeeIcon",
              variant: "success",
              text: `Se ha enviado la notificación con  éxito, No #${res.data.notification.id}`,
            },
          });
          _this.$emit("cerrarModalNotificacion");
        })
        .catch(function (error) {
          _this.errors = error.response.data.errors;
        })
        .finally(() => {
          _this.isSubmitting = false;
        });
    },
  },
  created() {
    this.getMedias();
    this.getDocuments();
    this.buildCountries();
  },
};
</script>
